import { useCallback, useEffect, useState } from "react";
import {
  Input,
  InputGroup,
  InputLeftElement,
  Flex,
  Button,
  Icon,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { debounce } from "lodash";
import { FiFilter, FiPlus } from "react-icons/fi";
import { BaseTableFiltersProps } from "./types";
import { BaseTableFiltersSkeleton } from "./Skeleton/BaseTableFiltersSkeleton";

export const BaseTableFilters = ({
  isShowSearch = true,
  handleSearch,
  placeHolderInput = "",
  searchValue,
  isShowBtnPopupFilters = true,
  selectedFiltersCount,
  popupFilters,
  isOpenPopupFilters,
  onClosePopupFilters,
  onClickBtnPopupFilters,
  isShowCreateButton = true,
  onClickCreate,
  isLoading,
  children,
}: BaseTableFiltersProps) => {
  const [searchValueState, setSearchValueState] = useState<string>("");

  useEffect(() => {
    if (searchValue !== undefined) {
      setSearchValueState(searchValue);
    }
  }, [searchValue]);

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      handleSearch?.(value);
    }, 500),
    [handleSearch],
  );

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const nextValue = e.target.value;
    setSearchValueState(nextValue);
    debouncedSearch(nextValue);
  };

  if (isLoading) return <BaseTableFiltersSkeleton />;

  return (
    <Flex gap="24px" justifyContent="space-between" backgroundColor="white" padding="24px" borderRadius="8px" border="1px solid #e1e7ef">
      <Flex gap="24px">
        {isShowSearch && (
          <InputGroup w="309px">
            <InputLeftElement pointerEvents="none">
              <SearchIcon color="gray.300" />
            </InputLeftElement>
            <Input type="text" w="309px" value={searchValueState} onChange={handleSearchChange} placeholder={placeHolderInput} fontSize="14px" />
          </InputGroup>
        )}
        {children}
        {isShowBtnPopupFilters && (
          <Popover placement="bottom-start" closeOnBlur isLazy strategy="fixed" isOpen={isOpenPopupFilters} onClose={onClosePopupFilters}>
            <PopoverTrigger>
              <Button
                leftIcon={<Icon as={FiFilter as any} boxSize={4} />}
                onClick={onClickBtnPopupFilters}
                bg="#2563eb"
                color="white"
                _hover={{ bg: "#2563eb" }}
                _active={{ bg: "#2563eb" }}
              >
                Фильтры
                {selectedFiltersCount && selectedFiltersCount > 0 ? (
                  <Flex
                    as="span"
                    ml="8px"
                    alignItems="center"
                    justifyContent="center"
                    bg="white"
                    color="#2563eb"
                    borderRadius="9999px"
                    minW="20px"
                    h="20px"
                    px="6px"
                    fontSize="12px"
                    fontWeight={700}
                  >
                    {selectedFiltersCount}
                  </Flex>
                ) : null}
              </Button>
            </PopoverTrigger>
            <PopoverContent w="max-content">
              <PopoverHeader>Фильтры</PopoverHeader>
              <PopoverBody>{popupFilters}</PopoverBody>
            </PopoverContent>
          </Popover>
        )}
      </Flex>
      {isShowCreateButton && (
        <Button
          leftIcon={<Icon as={FiPlus as any} boxSize={4} />}
          onClick={onClickCreate}
          bg="#2563eb"
          color="white"
          _hover={{ bg: "#2563eb" }}
          _active={{ bg: "#2563eb" }}
        >
          Создать
        </Button>
      )}
    </Flex>
  );
};
